/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

export const colors = {
  purple: {
    50: '#F2EEFA',
    100: '#E4DEF6',
    150: '#D3C8F0',
    200: '#C0B1EA',
    250: '#A994E2',
    300: '#9278DA',
    350: '#8162D4',
    400: '#7654D1',
    450: '#6D4ACD',
    500: '#6641CF',
    550: '#5D39C4',
    600: '#5534B2',
    650: '#4F30A5',
    700: '#452B8C',
    750: '#3B2673',
    800: '#30215B',
    850: '#281C4A',
    900: '#1F1736',
    950: '#171127',
  },
  blue: {
    50: '#E7F6FD',
    100: '#CBEBFB',
    150: '#AEE0F9',
    200: '#96D7F8',
    250: '#7ECEF6',
    300: '#66C5F4',
    350: '#4FBCF3',
    400: '#37B3F1',
    450: '#1FACEF',
    500: '#109EE5',
    550: '#0C92D4',
    600: '#0885C4',
    650: '#0977AE',
    700: '#086796',
    750: '#065379',
    800: '#04425D',
    850: '#03364A',
    900: '#022C3B',
    950: '#022531',
  },
  teal: {
    50: '#E9FAFB',
    100: '#D8F5F9',
    150: '#C2F0F5',
    200: '#B0ECF2',
    250: '#92E4ED',
    300: '#75DFEA',
    350: '#64DBE8',
    400: '#4ED5E4',
    450: '#42CEDB',
    500: '#36C9D4',
    550: '#27BCC4',
    600: '#1EAAAE',
    650: '#18949A',
    700: '#138286',
    750: '#17747D',
    800: '#136067',
    850: '#0F4C52',
    900: '#0C3C41',
    950: '#092C2F',
  },
  green: {
    50: '#E8F7F1',
    100: '#E8F7F1',
    150: '#C3EAD9',
    200: '#ACE2CB',
    250: '#92D9BB',
    300: '#77D4AD',
    350: '#5BD2A0',
    400: '#3FCA90',
    450: '#2CC384',
    500: '#1FBD7B',
    550: '#14B470',
    600: '#0DAA6A',
    650: '#0C9E64',
    700: '#0A8856',
    750: '#09774B',
    800: '#07643F',
    850: '#065133',
    900: '#043924',
    950: '#022115',
  },
  yellow: {
    50: '#FEF7E7',
    100: '#FDF0CE',
    150: '#FCEABA',
    200: '#FBE3A7',
    250: '#FBDD93',
    300: '#F8D781',
    350: '#F6D06A',
    400: '#F3CC4F',
    450: '#F0C32F',
    500: '#ECB90F',
    550: '#E5B107',
    600: '#DBA906',
    650: '#CC9E05',
    700: '#B88E05',
    750: '#9F7B04',
    800: '#866803',
    850: '#705603',
    900: '#554102',
    950: '#362A01',
  },
  orange: {
    50: '#FFE8E0',
    100: '#FFDDD1',
    150: '#FDC7B4',
    200: '#F9AE94',
    250: '#F4997B',
    300: '#E98463',
    350: '#E27450',
    400: '#D66843',
    450: '#CE603B',
    500: '#C85732',
    550: '#C05430',
    600: '#AE4B2B',
    650: '#9F4628',
    700: '#883B20',
    750: '#743019',
    800: '#5C2513',
    850: '#4B1D0E',
    900: '#36150A',
    950: '#270F06',
  },
  red: {
    50: '#FDE4E3',
    100: '#FBCECB',
    150: '#F8B4AF',
    200: '#F79E97',
    250: '#F4837B',
    300: '#F26D63',
    350: '#F05C4C',
    400: '#EF4D34',
    450: '#ED381C',
    500: '#E32E12',
    550: '#D72E14',
    600: '#CA2B13',
    650: '#BB2911',
    700: '#A82410',
    750: '#98200E',
    800: '#871D0D',
    850: '#70180A',
    900: '#591308',
    950: '#460F07',
  },
  pink: {
    50: '#FDE2EC',
    100: '#FBCBDC',
    150: '#F9AEC8',
    200: '#F896B8',
    250: '#F67EA8',
    300: '#F56B9B',
    350: '#F3588E',
    400: '#F24582',
    450: '#F13275',
    500: '#F0236B',
    550: '#EF1561',
    600: '#E5105A',
    650: '#DB0F5A',
    700: '#C80E52',
    750: '#B00C4B',
    800: '#8F0A3F',
    850: '#720833',
    900: '#560626',
    950: '#3E041B',
  },
  neutral: {
    50: '#F6F8F9',
    100: '#E6EDEF',
    150: '#D7E3E5',
    200: '#C9DADE',
    250: '#BFD0D4',
    300: '#B1C2C8',
    350: '#A6B4BA',
    400: '#9DA9AF',
    450: '#90A7B2',
    500: '#80A4B5',
    550: '#6E97AA',
    600: '#5C899E',
    650: '#50788B',
    700: '#456878',
    750: '#3A5764',
    800: '#2E4752',
    850: '#23353E',
    900: '#18242A',
    950: '#141F24',
  },
  gray: {
    0: '#FFFFFF',
    50: '#F9F9F6',
    100: '#F1F1ED',
    150: '#EBEAE6',
    200: '#E0DEDC',
    250: '#D5D4D3',
    300: '#C7C5C4',
    350: '#AAA9A7',
    400: '#9B9A97',
    450: '#8C8A87',
    500: '#7D7B78',
    550: '#787573',
    600: '#726F6C',
    650: '#676665',
    700: '#5A5958',
    750: '#4D4D4C',
    800: '#454442',
    850: '#2F3137',
    900: '#181D2A',
    950: '#0A0F1C',
    1000: '#000000',
  },
}
